import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { Invisible } from 'Views/Page/Content/Modal/Components/Modal/Invisible';
import { templateMap } from 'Views/Page/Content/Templates';
import Drawer from './Drawer';
import { LegacyDialog } from './Dialog/LegacyDialog';
import { Dialog2 } from './Dialog/Dialog2';
import { CelebrationDialog } from './Dialog/CelebrationDialog';
import Takeover from './Takeover/Takeover';
import { Layout as DefaultStepLayout, metaOverrideSet as DefaultStepMetaOverrideSet } from '../../Layouts/DefaultStep';

const defaultTemplate = {
  Layout: DefaultStepLayout,
  metaOverrideSet: DefaultStepMetaOverrideSet,
  modalType: 'legacy',
};

const PageModal = () => {
  const { modalCollection } = useModalContext();

  if (!modalCollection) {
    return null;
  }

  const headResource = modalCollection.resources().head();
  const {
    modalType = 'standard',
    ...modalProps
  } = templateMap[headResource.type()]?.modal ?? defaultTemplate;

  let ModalComponent;
  switch (modalType) {
    case 'drawer':
      ModalComponent = Drawer;
      break;
    case 'legacy':
      ModalComponent = LegacyDialog;
      break;
    case 'celebration':
      ModalComponent = CelebrationDialog;
      break;
    case 'takeover':
      ModalComponent = Takeover;
      break;
    case 'invisible':
      ModalComponent = Invisible;
      break;
    case 'standard':
      ModalComponent = Dialog2;
      break;
    default:
      ModalComponent = Dialog2;
      break;
  }

  return (
    <ModalComponent
      modalSize={'sm'}
      {...modalProps}
      test={`page-modal.${headResource.type()}`}
    />
  );
};

export default PageModal;
